import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  forwardRef,
  Input,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { IconSizesEnum } from '../../../icon/icon.component';

@Component({
  selector: 'i2g-rating-field',
  templateUrl: 'rating-field.component.html',
  styleUrls: ['rating-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingFieldComponent),
      multi: true,
    },
  ],
})
export class RatingFieldComponent implements OnInit, ControlValueAccessor {
  /**
   * Used for rating icon `name` attribute
   */
  @Input() name = 'rating';

  /**
   * Determine if rating is readonly
   */
  @Input() readonly = false;

  /**
   * Determine rating size
   */
  @Input() iconSize: IconSizesEnum = IconSizesEnum.medium;

  /**
   * Width in pixel, pass this for size `custom`
   */
  @Input() iconWidth: number;

  /**
   * Height in pixel, pass this for size `custom`
   */
  @Input() iconHeight: number;

  /**
   * max rating items
   */
  maxRatingIcon = 5;

  /**
   * rating icons
   */
  ratingIcons: { id: string; name: string; value: number }[];

  /**
   * Current selected rating value
   */
  value: number;

  /**
   * For ControlValueAccessor
   */
  onChange: any = () => {};

  /**
   * For ControlValueAccessor
   */
  onTouched: any = () => {};

  constructor() {}

  ngOnInit() {
    this.ratingIcons = Array.from(new Array(this.maxRatingIcon)).map(
      (_, index) => {
        const itemValue = index + 1;

        return {
          id: `${this.name}-${itemValue}`,
          name: this.name,
          value: itemValue,
        };
      }
    );
  }

  writeValue(value: number) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  onClickRatingIcon(selectedValue: number) {
    const shouldBeZeroRating = selectedValue === 1 && this.value === 1;

    this.value = shouldBeZeroRating ? 0 : selectedValue;

    this.onChange(this.value);
    this.onTouched();
  }
}
